/**
 * BI component management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class BIManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async createComponent(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/cdp_bi_component/create', { data });
  }

  async deleteComponent(uuid: string): Promise<Record<string, any>> {
    return this.session.post(`/api/cdp/cdp_bi_component/delete/${uuid}`);
  }

  async updateComponent(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/cdp_bi_component/update', { data });
  }

  async setSubjectMapInfo(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/cdp_bi_subject/extend/setMapInfo', { data });
  }

  async getGeoRole(uuid: string): Promise<Record<string, any>> {
    return this.session.get(`/api/cdp/cdp_geo_role/get/${uuid}`);
  }

  async listGeoRoles(page = 1, size = 20, params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/cdp_geo_role/page', {
      params: { current: page, size, ...params },
    });
  }

  async listGeoEntities(page = 1, size = 20, params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/cdp_geo_entity/page', {
      params: { current: page, size, ...params },
    });
  }
}
